import { useSuspenseQuery } from '@tanstack/react-query';

import {
  getCourseValidationOptions,
  useValidateCourse,
} from '@/module/Author/Course/Validation/model/CourseValidationModel';

import { Id, useAppNotification } from '@feature/utils';
import { ValidationRequest, ValidationVariant } from '@feature/validation';
import { ValidationAction } from '@feature/validation/ValidationAction';

interface ValidationActionProps {
  courseId: Id;
  variant?: ValidationVariant;
}

export function CourseValidationAction({ courseId, variant }: ValidationActionProps) {
  const { data } = useSuspenseQuery(getCourseValidationOptions(courseId));
  const notification = useAppNotification();
  const { mutate, isPending } = useValidateCourse(courseId);

  const onSubmit = (request: ValidationRequest) => {
    mutate(request, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <ValidationAction
      validation={data}
      isPending={isPending}
      onSubmit={onSubmit}
      variant={variant}
    />
  );
}
